/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TagValueTypeFromJSON, TagValueTypeToJSON, } from './';
export function NamedResourceTagFromJSON(json) {
    return NamedResourceTagFromJSONTyped(json, false);
}
export function NamedResourceTagFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'valueType': TagValueTypeFromJSON(json['valueType']),
        'predefinedValuesOnly': json['predefinedValuesOnly'],
        'values': !exists(json, 'values') ? undefined : json['values']
    };
}
export function NamedResourceTagToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'valueType': TagValueTypeToJSON(value.valueType),
        'predefinedValuesOnly': value.predefinedValuesOnly,
        'values': value.values
    };
}
